import { Component, Input, OnInit } from "@angular/core";
import { CONSTANTS } from "app/constants";
import { NationalCupCountriesDto, NationalCupPairsDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawing-national-pairs',
    templateUrl: './drawing-national-pairs.component.html',
    styleUrls: ['./drawing-national-pairs.component.scss'],
})
export class DrawingNationalPairs implements OnInit {

    stages: any[] = [];

    matchDay: number;

    @Input()
    stage: number;

    const;

    pairs: NationalCupCountriesDto;
    
    isProcessing: boolean = false;

    fixtures: NationalCupPairsDto[];

    constructor(private drawingService: DrawingsService,
        private notificationService: NotificationService
    ) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildEuroStagesDictionary();
        this.loadPairs();
    } 

    getStageLabel(): string {
        return this.stages[this.stage];
    }

    doDraw() {
        if (!this.matchDay) {
            this.notificationService.showError('Не заполнен ИД');
            return;
        }
        this.isProcessing = true;
        this.drawingService.drawNationalCup(this.matchDay, this.stage)
            .subscribe(result => {

                this.fixtures = result.countries;
                this.isProcessing = false;
                this.notificationService.showSuccess('Жеребьевка проведена.');
            }, error => {
                this.isProcessing = false;
                this.notificationService.showError('Ошибка жеребьевки');
            })

    }

    private buildEuroStagesDictionary() {
        this.stages = [];
        this.stages[CONSTANTS.euroCupStages.playoff32] = CONSTANTS.euroCupStagesNames.playoff32;
        this.stages[CONSTANTS.euroCupStages.playoff16] = CONSTANTS.euroCupStagesNames.playoff16;
        this.stages[CONSTANTS.euroCupStages.playoff8] = CONSTANTS.euroCupStagesNames.playoff8;
        this.stages[CONSTANTS.euroCupStages.playoff4] = CONSTANTS.euroCupStagesNames.playoff4;
        this.stages[CONSTANTS.euroCupStages.playoff2] = CONSTANTS.euroCupStagesNames.playoff2;
        this.stages[CONSTANTS.euroCupStages.final] = CONSTANTS.euroCupStagesNames.final;
    }

    private loadPairs() {
        this.isProcessing = true;
        this.drawingService.getNationalCupPairs(this.stage)
            .subscribe(result => {
                this.pairs = result;

                this.isProcessing = false;
            }, error => {
                this.notificationService.showError("Ошибка загрузки пар.")
                this.isProcessing = false;
            })
    }
}

